module.exports = __webpack_public_path__ + "static/media/ladysbag.08fa0950.jpg";